// the customer screen is a counter display on a cheap tablet: it loads only its
// own small chunk, not the whole app (App.js imports every page up front)
const CUSTOMER_SCREEN_PATH = "/customer-screen";

if (window.location.pathname.startsWith(CUSTOMER_SCREEN_PATH)) {
  import("./modules/customerScreen/boot");
} else {
  import("./main");
}
